import { render } from "./DialogSystem.vue?vue&type=template&id=61b590df&ts=true"
import script from "./DialogSystem.vue?vue&type=script&lang=ts"
export * from "./DialogSystem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__